module.exports = __webpack_public_path__ + "img/creativo-vignette.fc368414.jpg";